import { createUseStyles } from 'react-jss';
import { getBreakpointValueWithUnit } from '../../theme';
const modalPropertiesPerSize = {
    small: {
        maxWidth: '700px',
        margin: 'auto',
    },
    medium: {
        maxWidth: '900px',
        margin: '12% auto',
    },
    large: {
        maxWidth: '1024px',
        margin: '60px auto',
    },
    xLarge: {
        maxWidth: '1184px',
        margin: '60px auto',
    },
};
export const useModalClasses = createUseStyles((theme) => ({
    modal: (props) => modalPropertiesPerSize[props.size || 'small'],
    'modal-body': (props) => ({
        padding: props.size === 'small' || props.size === 'medium' ? '48px 100px' : '48px 60px',
    }),
    description: (props) => ({
        ...props.theme.typography.variants['body-large'],
        color: props.theme.colors.slathe,
        marginBottom: props.theme.space.base,
    }),
    icon: {
        position: 'absolute',
        top: '24px',
        right: '20px',
    },
    content: (props) => ({
        visibility: props.isLoading ? 'hidden' : 'visible',
    }),
    [`@media (max-width: ${getBreakpointValueWithUnit({ theme, breakpoint: 'lg' })})`]: {
        modal: () => ({
            maxWidth: '100%',
            margin: '0',
            '&:after': {
                display: 'none',
            },
        }),
        'modal-body': () => ({
            padding: '48px 24px 40px',
            margin: '40px 12px 0',
        }),
    },
    [`@media (min-width: ${getBreakpointValueWithUnit({ theme, breakpoint: 'lg' })})`]: {
        icon: () => ({
            top: '20px',
            right: '16px',
        }),
    },
}));
